import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../conexoes/api'
import { revelarExibirColunas } from '../../redux/actions/index'
import { elipseVerde, fecharJanela } from '../../utils/alternanciaIcones'
import '../../css/personalizarColunas/personalizarColunas.css'
import { getColunasClienteNivelN3 } from '../../utils/colunas'
import decryptJWT from '../../utils/decryptJWT'
import { isPortal } from '../../utils/nivelCliente'
import { validadorPermissaoElemento } from '../../utils/verificadorPermissaoElemento'

import {
  ItemColunasCategoria,
  ListaColunasCategoria,
  TituloBotaoColunas,
  TrianguloPersonalizar
} from './CardCategoriaColuna'
import { objCategoriasKeys } from './dados'
import {
  alterarExibirColunas,
  getDadosColunas,
  getNomesCategoriasColunas,
  handlerAtualizarDados
} from './funcoesPersonalizarColunas'

let categoriasColunas = []
const nomesCategorias = getNomesCategoriasColunas(objCategoriasKeys)

nomesCategorias.map((key) => (categoriasColunas[key] = [])) // iniciar categoriasColunas

const limpaCategorias = () => {
  Object.keys(categoriasColunas).map((key) => (categoriasColunas[key] = [])) // esvazia todas as categorias
}

let itensAtivos = 0
// let colunas = []
export default function PersonalizarColunas(props) {
  const portalCliente = isPortal()

  const [arraySelecionado, setArraySelecionado] = useState('')
  const [itenSelecionado, setItenSelecionado] = useState('')
  const [colunas, setColunas] = useState(undefined)
  const [render, setRender] = useState(false)
  const despacho = useDispatch()
  const { handleSubmit } = useForm()
  const modal = useRef()
  const [categoria, setCategoria] = useState(0)
  const [permissaoFaturas, setPermissaoFaturas] = useState()

  const hasPrivate = decryptJWT('userHasPrivateNetworks')

  const permissaoElemento = useSelector(
    (state) => state.permissaoState.permissaoElemento
  )

  const handleClickFora = (e) => {
    if (!modal?.current?.contains(e.target)) {
      handleCancelar()
    }
  }

  async function handleCancelar(valor) {
    if (valor === true) {
      props.setRender(!props.render)
      props.setRenderizar(!props.renderizar)
    }
    despacho(revelarExibirColunas(false))
  }

  async function handleSalvar() {
    alterarExibirColunas({ colunasConectividade: colunas }).then(() => {
      handleCancelar(true)
    })
  }

  useEffect(() => {
    limpaCategorias()

    const handlerInserirDados = (colunas) => {
      if (portalCliente) {
        colunas = getColunasClienteNivelN3(colunas, 'id')
      }

      if (hasPrivate) {
        colunas = colunas.filter((c) => c.id !== 'VALOR_PLANO')
      }

      const dados = getDadosColunas({
        colunas,
        itensAtivos,
        objCategoriasKeys,
        categoriasColunas
      })
      categoriasColunas = dados.categoriasColunas

      setColunas(colunas)
    }

    async function handlerCarregarDados() {
      await api_gateway
        .get(
          '/m1/servicos/token/buscar_colunas_simcard?email=' +
            decryptJWT('email')
        )
        .then(function (response) {
          if (response.data.dados) {
            //   login(response.data.dados);
            handlerInserirDados(response.data.dados.colunas)
          } else {
            //   setLoginError(response.data.info);
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    }
    handlerCarregarDados()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function handlerPermissao() {
      setPermissaoFaturas(
        await validadorPermissaoElemento(
          permissaoElemento,
          'veye/dispositivos/colunasFaturas'
        )
      )
    }
    handlerPermissao()
  }, [permissaoElemento])

  useEffect(() => {
    async function altualizaDados() {
      if (colunas !== undefined) {
        const resAtualizaDados = await handlerAtualizarDados({
          colunas,
          itenSelecionado,
          setColunas,
          arraySelecionado,
          itensAtivos,
          categorias: categoriasColunas
        })

        categoriasColunas = resAtualizaDados.categorias
        itensAtivos = resAtualizaDados.itensAtivos
      }
    }
    altualizaDados()

    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [render])

  function handlerChangeSwitich(id, array) {
    setRender(!render)
    setItenSelecionado(id)
    setArraySelecionado(array)
  }

  const CardCategoria = ({ categoriaItem, titulo }) => {
    const itemSelecionado = categoria === categoriaItem
    return (
      <>
        {itemSelecionado && <TrianguloPersonalizar />}
        <div
          className={`container-switches-exibir-colunas-2 ${itemSelecionado ? 'fundo-cor-8' : ''}`}
          onClick={() => setCategoria(categoriaItem)}
        >
          <TituloBotaoColunas titulo={titulo} />
        </div>
      </>
    )
  }

  const Simcard = categoriasColunas['Simcard']
  const Conectividade = categoriasColunas['Conectividade']
  const Utilizacao = categoriasColunas['Utilizacao']
  const Contrato = categoriasColunas['Contrato']
  const Dispositivo = categoriasColunas['Dispositivo']
  const Identificacao = categoriasColunas['Identificacao']
  const Cliente = categoriasColunas['Cliente']

  const clienteNivel = decryptJWT('clienteNivel') // test

  return (
    <Form
      key="personalizar-colunas"
      ref={modal}
      onSubmit={handleSubmit(() => handleSalvar())}
    >
      <div className="modal-exibir-colunas fundo-cor-6">
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Exibir colunas</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Label>
              <div className="fonte-cor-1 label-titulo-colunas">
                Permissões de acesso de perfil
              </div>
            </Form.Label>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="grupo-exibir-colunas">
              <div className="coluna-exibir-colunas-1 fundo-cor-5">
                <CardCategoria titulo="SIM card" categoriaItem={1} />
                <CardCategoria titulo="Conectividade" categoriaItem={2} />
                <CardCategoria titulo="Utilização" categoriaItem={3} />
                <CardCategoria titulo="Contrato" categoriaItem={4} />
                <CardCategoria titulo="Dispositivo" categoriaItem={5} />
                <CardCategoria titulo="Identificação" categoriaItem={6} />

                {!portalCliente && (
                  <CardCategoria titulo="Cliente" categoriaItem={7} />
                )}
              </div>

              <div className="coluna-exibir-colunas-2 fundo-cor-8">
                {categoria === 1 && (
                  <div className="container-switches-exibir-colunas">
                    {Simcard?.map((i, item) => (
                      <React.Fragment key={i.id}>
                        {i.nivel_acesso >= clienteNivel && (
                          <>
                            {i.id.split('FAT_').length >= 2 &&
                            !permissaoFaturas ? (
                              <div className="" />
                            ) : (
                              <ItemColunasCategoria
                                item={Simcard[item]}
                                categoriaKey="Simcard"
                                handlerChangeSwitich={handlerChangeSwitich}
                              />
                            )}
                          </>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                )}
                {categoria === 2 && (
                  <div className="container-switches-exibir-colunas">
                    {Conectividade?.map((i, item) => (
                      <React.Fragment key={i.id}>
                        {i.nivel_acesso >= clienteNivel && (
                          <>
                            {i.id.split('FAT_').length >= 2 &&
                            !permissaoFaturas ? (
                              <div className="" />
                            ) : (
                              <ItemColunasCategoria
                                item={Conectividade[item]}
                                categoriaKey="Conectividade"
                                handlerChangeSwitich={handlerChangeSwitich}
                              />
                            )}
                          </>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                )}
                {categoria === 3 && (
                  <ListaColunasCategoria
                    listaCategoria={Utilizacao}
                    categoriaKey="Utilizacao"
                    handlerChangeSwitich={handlerChangeSwitich}
                  />
                )}
                {categoria === 4 && (
                  <ListaColunasCategoria
                    listaCategoria={Contrato}
                    categoriaKey="Contrato"
                    handlerChangeSwitich={handlerChangeSwitich}
                  />
                )}
                {categoria === 5 && (
                  <ListaColunasCategoria
                    listaCategoria={Dispositivo}
                    categoriaKey="Dispositivo"
                    handlerChangeSwitich={handlerChangeSwitich}
                  />
                )}
                {categoria === 6 && (
                  <ListaColunasCategoria
                    listaCategoria={Identificacao}
                    categoriaKey="Identificacao"
                    handlerChangeSwitich={handlerChangeSwitich}
                  />
                )}
                {categoria === 7 && (
                  <ListaColunasCategoria
                    listaCategoria={Cliente}
                    categoriaKey="Cliente"
                    handlerChangeSwitich={handlerChangeSwitich}
                  />
                )}
              </div>
            </div>
          </Col>
        </Form.Row>

        <Form.Row className="container-botoes-cancelar-confirmar">
          <Col>
            <>
              <Button
                type="submit"
                className="botao-confirmar"
                variant="success"
                size="sm"
              >
                <div className="fonte-cor-4">Confirmar</div>
              </Button>

              <Button
                className="botao-cancelar"
                variant="success"
                size="sm"
                onClick={() => handleCancelar()}
              >
                <div className="fonte-cor-2">Cancelar</div>
              </Button>
            </>
          </Col>
        </Form.Row>
      </div>
    </Form>
  )
}
